import api from './api';

export const projectService = {
  async getAll() {
    const response = await api.get('/projetos');
    return response.data;
  },

  async getById(projectId) {
    const response = await api.get(`/projetos/${projectId}`);
    return response.data;
  },

  async create(projectData) {
    const response = await api.post('/projetos', projectData);
    return response.data;
  },

  async update(projectId, projectData) {
    const response = await api.put(`/projetos/${projectId}`, projectData);
    return response.data;
  },

  async delete(projectId) {
    const response = await api.delete(`/projetos/${projectId}`);
    return response.data;
  },

  async getSubtasks(projectId) {
    const response = await api.get(`/projetos/${projectId}/subtarefas`);
    return response.data;
  },

  async createSubtask(projectId, subtaskData) {
    const response = await api.post(`/projetos/${projectId}/subtarefas`, subtaskData);
    return response.data;
  },

  async updateSubtask(projectId, subtaskId, subtaskData) {
    const response = await api.put(`/projetos/${projectId}/subtarefas/${subtaskId}`, subtaskData);
    return response.data;
  },

  async deleteSubtask(projectId, subtaskId) {
    const response = await api.delete(`/projetos/${projectId}/subtarefas/${subtaskId}`);
    return response.data;
  },

  async exportProjectPDF(projectId) {
    try {
      const response = await api.get(`/projetos/${projectId}/export-pdf`, {
        responseType: 'blob',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      
      // Criar link temporário para download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `projeto_${projectId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      return { success: true };
    } catch (error) {
      console.error('Erro ao exportar PDF:', error);
      throw error;
    }
  }
};